import styled from 'styled-components';


export const StyledRadioWrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 10px 0;
`

export const StyledRadioInput = styled.input`
    position: static;
    margin: 0 0 0 20px;
    width: 20px;
    height: 20px;
`

export const StyledLabel = styled.label`
    display: flex;
    align-items: center;

    .dropdown {
        width: 200px;
        margin: 0 20px;
    };
`